export class InterpreterHasNoInterpretedParticipantError extends Error {
  constructor() {
    super('This interpreter no longer has a participant to interpret for.')
    Object.setPrototypeOf(this, InterpreterHasNoInterpretedParticipantError.prototype)
  }
}
